import React, { useState, useEffect, useRef } from "react";
import "./styles.css"; // Import the CSS file
import DownArrow from "../icons/downArrow.svg";
import UpArrow from "../icons/upArrow.svg";
import CalendarIcon from "../icons/calendor-icon.png";

interface DropdownProps {
  options: string[];
  selected?: string | number;
  onSelect: (option: string, index: number) => void;
}

const Dropdown: React.FC<DropdownProps> = ({ options, selected, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentSelection, setCurrentSelection] = useState<string>(options[0]);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (selected !== undefined) {
      if (typeof selected === "number" && options[selected] !== undefined) {
        setCurrentSelection(options[selected]);
      } else if (typeof selected === "string") {
        setCurrentSelection(selected);
      }
    }
  }, [selected, options]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (option: string, index: number) => {
    setCurrentSelection(option);
    onSelect(option, index);
    setIsOpen(false);
  };

  return (
    <div className="dropdown" ref={dropdownRef}>
      <button
        onClick={toggleDropdown}
        className={`dropdown-button ${isOpen ? "open" : ""}`}
      >
        {currentSelection}
        <img
          src={isOpen ? DownArrow : UpArrow}
          alt="Arrow"
          className="dropdown-arrow"
        />
      </button>
      <div className={`dropdown-menu ${isOpen ? "open" : ""}`}>
        {options.map(
          (option, originalIndex) =>
            option !== currentSelection && (
              <div
                key={originalIndex}
                onClick={() => handleOptionClick(option, originalIndex)}
                className="dropdown-item"
              >
                {option}
              </div>
            )
        )}
      </div>
    </div>
  );
};

export default Dropdown;

export const CalendarDropdown: React.FC<DropdownProps> = ({
  options,
  selected,
  onSelect,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentSelection, setCurrentSelection] = useState<string>(options[0]);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (selected !== undefined) {
      if (typeof selected === "number" && options[selected] !== undefined) {
        setCurrentSelection(options[selected]);
      } else if (typeof selected === "string") {
        setCurrentSelection(selected);
      }
    }
  }, [selected, options]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (option: string, index: number) => {
    setCurrentSelection(option);
    onSelect(option, index);
    setIsOpen(false);
  };

  return (
    <div className="dropdown" ref={dropdownRef}>
      <button
        onClick={toggleDropdown}
        className={`dropdown-button dropdown-calendar ${isOpen ? "open" : ""}`}
      >
        {currentSelection}
        <img
          src={CalendarIcon}
          width={14}
          height={14}
          alt="Arrow"
          className="dropdown-arrow"
        />
      </button>
      <div className={`dropdown-menu ${isOpen ? "open" : ""}`}>
        {options.map(
          (option, originalIndex) =>
            option !== currentSelection && (
              <div
                key={originalIndex}
                onClick={() => handleOptionClick(option, originalIndex)}
                className="dropdown-item"
              >
                {option}
              </div>
            )
        )}
      </div>
    </div>
  );
};
